import { ImpressionSource } from 'src/app/@utils/gtm-tracking/events/trackProductImpressionEvent';
import { isDefined } from 'src/app/@utils/is-defined';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GtmService } from '@core/services/gtm/gtm.service';
import { ProductDetailViewModel } from '@models/api-search.models';
import { Router, RouterLink } from '@angular/router';
import { GetCampaignTypePipe } from '../pipes/get-campaign-type.pipe';
import { StringTruncatePipe } from '@shared/string-truncate/string-truncate.pipe';
import { ProductActionsComponent } from '@features/product/product-actions/product-actions.component';
import { ProductPriceComponent } from '@features/product/product-price/product-price.component';
import { BrandLinkComponent } from '@shared/brand-link/brand-link.component';
import { ProductSplashesComponent } from '@features/product/product-splashes/product-splashes.component';
import { NgClass, NgIf } from '@angular/common';
import { ProductImageComponent } from '@shared/image/product-image/product-image.component';
import { ProductCardLayout } from '@features/product/product.models';

@Component({
    selector: 'app-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ProductImageComponent,
        NgIf,
        ProductSplashesComponent,
        BrandLinkComponent,
        NgClass,
        ProductPriceComponent,
        RouterLink,
        ProductActionsComponent,
        StringTruncatePipe,
        GetCampaignTypePipe
    ]
})
export class ProductCardComponent {
    @Input()
    public line: ProductDetailViewModel & { index?: number };

    @Input()
    public compressed?: boolean = false;

    @Input()
    public layout?: ProductCardLayout = 'normal';

    @Input()
    public displayActions?: boolean = false;

    @Input()
    public displayCampaigns?: boolean = true;

    @Input()
    public queryParamsHandling: 'merge' | 'preserve' | '' = '';

    @Input()
    public impressionSource?: ImpressionSource = 'Other';

    @Input()
    public readonly index?: number;

    constructor(
        private readonly gtmService: GtmService,
        private readonly router: Router
    ) {}

    public productClick(line: ProductDetailViewModel): void {
        this.gtmService.trackMenuNavigation(this.router.url, line.productNo, line.productName);

        this.gtmService.trackingEvents.trackProductClick(
            {
                ...line,
                ...(isDefined<number>(this.index) ? { index: this.index } : {})
            },
            this.impressionSource
        );
    }
}
